module.exports = __webpack_public_path__ + "static/Hotel-633f84e7b1e225c5b8a70e3a4f8cf5ba.jpg";